export default __webpack_public_path__ + "static/boge-service_montage-und-lieferung2-f8b5e3744d8d9922b690ca422b4fe222.jpeg";